import bar from '@/charts/themes/bar.js'
import dsm_out_put from '@/charts/themes/dsm_out_put.js'
import blue_grad_bar from '@/charts/themes/blue_grad_bar.js'
import dashboard_bar1 from '@/charts/themes/dashboard_bar1.js'
import dashboard_bar2 from '@/charts/themes/dashboard_bar2.js'
import dashboard_line from '@/charts/themes/dashboard_line.js'
import energyOption_bar from '@/charts/themes/energyOption_bar.js'
import green_grad_bar from '@/charts/themes/green_grad_bar.js'
import green_line from '@/charts/themes/green_line.js'
import green_progress_ring from '@/charts/themes/green_progress_ring.js'
import hbar from '@/charts/themes/hbar.js'
import index_bar1 from '@/charts/themes/index_bar1.js'
import index_hbar from '@/charts/themes/index_hbar.js'
import index_line from '@/charts/themes/index_line.js'
import index_pie from '@/charts/themes/index_pie.js'
import index_ring from '@/charts/themes/index_ring.js'
import index_rose from '@/charts/themes/index_rose.js'
import line from '@/charts/themes/line.js'
import mapring from '@/charts/themes/mapring.js'
import nolabel_ring from '@/charts/themes/nolabel_ring.js'
import orange_bar from '@/charts/themes/orange_bar.js'
import orange_line from '@/charts/themes/orange_line.js'
import proportion_ring from '@/charts/themes/proportion_ring.js'
import purplebar from '@/charts/themes/purplebar.js'
import redhbar from '@/charts/themes/redhbar.js'
import ring from '@/charts/themes/ring.js'
import waring_line from '@/charts/themes/waring_line.js'
import Xaxis_show from '@/charts/themes/Xaxis_show.js'
import doubleBar from '@/charts/themes/doubleBar.js'
import doubleLine from '@/charts/themes/doubleLine.js'
import lineBar from '@/charts/themes/line_bar.js'
import green_ring from '@/charts/themes/green_ring.js'
import yellow_ring from '@/charts/themes/yellow_ring.js'
import red_ring from '@/charts/themes/red_ring.js'
import blue_ring from '@/charts/themes/blue_ring.js'
import darkBlue_ring from '@/charts/themes/darkBlue_ring.js'
import mbar from '@/charts/themes/mbar.js'
import wellDetailLine from '@/charts/themes/wellDetailLine.js'
import line_circle from '@/charts/themes/line_circle.js'

//epp
import line_ele from '@/charts/themes/epp/line_ele.js'
import green_bar from '@/charts/themes/epp/green_bar.js'
import twoGreen from '@/charts/themes/epp/twoGreen.js'
import orangeRed_bar from '@/charts/themes/epp/orangeRed_bar.js'
import twoBlue_ring from '@/charts/themes/epp/twoBlue_ring.js'
import warn_line from '@/charts/themes/epp/warn_line.js'
import twoRed from '@/charts/themes/epp/twoRed.js'
import dashboard_ring from '@/charts/themes/epp/dashboard_ring.js'
import dashboard_ring2 from '@/charts/themes/epp/dashboard_ring2.js'
import blueRed from '@/charts/themes/epp/blueRed.js'
import colors_bar from '@/charts/themes/epp/colors_bar.js'
import line_ele_comp from '@/charts/themes/epp/line_ele_comp.js'
import darkDarkBlue from '@/charts/themes/epp/darkDarkBlue_ring.js'
import darkBlue_bar from '@/charts/themes/epp/darkBlue_bar.js'
import bigScreen1 from '@/charts/themes/epp/bigScreen1.js'
import bigScreenBar1 from '@/charts/themes/epp/bigScreenBar1.js'
import bigScreenBar2 from '@/charts/themes/epp/bigScreenBar2.js'

export default {
    bar,
    dsm_out_put,
    blue_grad_bar,
    dashboard_bar1,
    dashboard_bar2,
    dashboard_line,
    energyOption_bar,
    green_grad_bar,
    green_line,
    green_progress_ring,
    hbar,
    index_bar1,
    index_hbar,
    index_line,
    index_pie,
    index_ring,
    index_rose,
    line,
    mapring,
    nolabel_ring,
    orange_bar,
    orange_line,
    proportion_ring,
    purplebar,
    redhbar,
    ring,
    waring_line,
    Xaxis_show,
    doubleBar,
    doubleLine,
    lineBar,
    green_ring,
    yellow_ring,
    red_ring,
    blue_ring,
    darkBlue_ring,
    mbar,
    wellDetailLine,
    line_circle,
    //epp
    line_ele,
    green_bar,
    twoGreen,
    orangeRed_bar,
    twoBlue_ring,
    warn_line,
    twoRed,
    dashboard_ring,
    dashboard_ring2,
    blueRed,
    colors_bar,
    line_ele_comp,
    darkDarkBlue,
    darkBlue_bar,
    bigScreen1,
    bigScreenBar1,
    bigScreenBar2
}


// WEBPACK FOOTER //
// ./src/model/chartTheme.js